import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-config';
import './testHooks'; // test-only window.__e2eSeed hook; compiled out of production builds

// Try to import amplify_outputs.json for Data API configuration
let amplifyOutputs;
try {
  amplifyOutputs = require('./amplify_outputs.json');
} catch (e) {
  console.warn('amplify_outputs.json not found - backend may not be deployed yet');
  amplifyOutputs = null;
}

// Configure Amplify with your backend resources
if (amplifyOutputs) {
  console.log('✅ Configuring Amplify with amplify_outputs.json');
  
  try {
    // For Amplify Gen 2, pass outputs directly - this automatically configures
    // Auth, Data (GraphQL API), and Storage all at once
    Amplify.configure(amplifyOutputs);
    
    console.log('✅ Amplify configured successfully');
    
    // Log configuration details for debugging
    if (amplifyOutputs.auth) {
      console.log('✅ Auth configured:', {
        userPoolId: amplifyOutputs.auth.user_pool_id,
        region: amplifyOutputs.auth.aws_region
      });
    }
    
    if (amplifyOutputs.data) {
      console.log('✅ Data API (GraphQL) configured:', {
        url: amplifyOutputs.data.url,
        region: amplifyOutputs.data.aws_region,
        authType: amplifyOutputs.data.default_authorization_type,
        hasModels: !!amplifyOutputs.data.model_introspection
      });
    } else {
      console.warn('⚠️ GraphQL API not available. Please deploy the backend with: npm run sandbox');
    }
    
    if (amplifyOutputs.storage) {
      console.log('✅ Storage configured:', {
        bucket: amplifyOutputs.storage.bucket_name,
        region: amplifyOutputs.storage.aws_region
      });
    }
    
  } catch (error) {
    console.error('❌ Error configuring Amplify:', error);
    console.error('Error details:', error.message, error.stack);
    
    // Fallback: configure manually
    console.log('Attempting manual configuration fallback...');
    
    const amplifyConfig = {
      Auth: {
        Cognito: {
          userPoolId: amplifyOutputs.auth?.user_pool_id,
          userPoolClientId: amplifyOutputs.auth?.user_pool_client_id,
          identityPoolId: amplifyOutputs.auth?.identity_pool_id,
          loginWith: { email: true }
        }
      }
    };
    
    // Add Data API configuration if available
    if (amplifyOutputs.data) {
      amplifyConfig.API = {
        GraphQL: {
          endpoint: amplifyOutputs.data.url,
          region: amplifyOutputs.data.aws_region || 'us-east-1',
          defaultAuthMode: 'userPool'
        }
      };
    }
    
    Amplify.configure(amplifyConfig);
    console.log('✅ Amplify configured with manual fallback');
  }
} else {
  // Fallback to Auth-only configuration
  console.log('Configuring Amplify with Auth-only configuration');
  console.warn('⚠️ amplify_outputs.json not found. Using environment variables.');
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: awsConfig.userPoolId,
        userPoolClientId: awsConfig.userPoolWebClientId,
        identityPoolId: awsConfig.identityPoolId,
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

